
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class InvoiceObjectionModel extends Model<InvoiceObjectionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'companyId', type: 'string' },
		{ name: 'documentNo', type: 'string' },
		{ name: 'comment', type: 'string' },
		{ name: 'userId', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'registeredDate', type: 'Date' },
		{ name: 'reasonId', type: 'string' },
		{ name: 'brandId', type: 'string' }
	];
	[key: string]: any;
	
	public id?: string;
	public companyId?: string;
	public documentNo: string;
	public comment: string;
	public userId?: string;
	public created?: Date;
	public registeredDate?: Date;
	public reasonId?: string;
	public brandId?: string;
    
	constructor(){
		super();
		this.id = undefined;
		this.companyId = undefined;
		this.documentNo = '';
		this.comment = '';
		this.userId = undefined;
		this.created = undefined;
		this.registeredDate = undefined;
		this.reasonId = undefined;
		this.brandId = undefined;
		
	}
	getProperties(){
		return InvoiceObjectionModel.classProperties;
	}
}

